import { SERVICES } from "@/lib/site";
import { MaskReveal, FadeUp } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const CONTRACT_IMG =
  "https://images.pexels.com/photos/8815849/pexels-photo-8815849.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-[#F8F9FA] py-24 md:py-36">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="overline text-[#B8962E] mb-6">/ How We Serve</div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <MaskReveal as="h2"
            className="font-serif-display text-[#0A1128] text-4xl md:text-5xl lg:text-6xl leading-[1.02] mb-10"
            lines={["Services engineered", "for outcomes."]} />
          <Accordion type="single" collapsible defaultValue="item-0" className="border-t border-[#E5E7EB]">
            {SERVICES.map((s, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`service-item-${i}`}
                className="border-b border-[#E5E7EB]">
                <AccordionTrigger className="py-6 text-left hover:no-underline group">
                  <span className="flex items-center gap-5">
                    <span className="font-mono-meta text-[#D4AF37] text-sm">0{i + 1}</span>
                    <span className="font-serif-display text-2xl md:text-3xl text-[#0A1128] group-hover:text-[#B8962E] transition-colors">{s.title}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pl-12">
                  <p className="font-body text-[#4b5563] text-base leading-relaxed max-w-lg">{s.desc}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <FadeUp>
            <div className="overflow-hidden border border-[#E5E7EB]">
              <img src={CONTRACT_IMG} alt="Signing a legal contract"
                className="w-full h-[380px] md:h-[560px] object-cover hover:scale-105 transition-transform duration-[6000ms]" />
            </div>
          </FadeUp>
        </div>
      </div>
    </div>
  </section>
);
